<template>
  <!--登录-->
  <div class="login_SignIn">
    <div class="">
      <!--header start-->
      <div class="header login-header">
        <a href="javascript:void(0);" @click="fn" class="icon-back"></a>
       央视账号登录
       <!-- <div>
          <span class="close" @click="fn"></span>
        </div>-->
        <!--<a href="javascript:void(0);" @click="fn" class="icon-out"></a>-->
      </div>

      <div class="line-gray"></div>
      <!--header end-->
      <!--content start-->
      <div class="login-content">
        <form class="lg-tabbox" id="punishformID">
          <div class="group-item">
            <label><i class="icon-lg-accout"></i></label>
            <div class="input-box input-tel"  style="padding-left: 5em">
              <input type="text" placeholder="请输入邮箱或手机" name="username" id="username" v-model="userName"/>
              <div class="btn-del" style="display: none" v-show="userName!= ''" @click="userName = ''">
              </div>
            </div>
          </div>
          <p class="text-danger uname" style="display: none">输入格式有误，请使用邮箱或手机号登录</p>
          <div class="group-item">
            <label><i class="icon-lg-password"></i></label>
            <div class="input-box input-tel"  style="padding-left: 5em">
              <input type="password" placeholder="请输入密码" name="password" id="password" v-model="password"/>
              <div class="btn-del" style="display: none" v-show="password!= ''" @click="password = ''">
              </div>
            </div>
          </div>
          <p class="text-danger upass" style="display: none">密码错误，请重输。</p>
          <div class="group-info">
            <a href="javascript:void(0);" class="font-lgr">
              登&nbsp;&nbsp;录
            </a>
          </div>
          <div class="group-mess">
            <router-link to="/repassword" tag="a">
              忘记密码
            </router-link>
            <a href="javascript:void(0);" @click="table" style="float: right">
              手机登录
            </a>
            <!--<span style="padding: 0 5px;float: right">|</span>
          <a href="javascript:void(0);" style="float: right" @click="signIn">
             第三方登录
           </a>-->
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
      data (){
        return {
          userName: '',  //userN
          password: ''   //password
        }
      },
      methods: {
          //操作按钮事件
        fn(){
          $('#login_Alert').modal('hide');
          $('#myFlash').show();
        },
        table(){
          $('.quick-alert').show();
          $('.signIn-alert').hide();
        },
        signIn(){
          $('.quick-alert').hide();
          $('.signIn-alert').hide();
         // $('#login_Alert').modal('hide');
         // this.$router.push({name:'login_SignIn'})
        }
      },
      mounted: function () {
          // var form=$document.forms['eg']；
          var that = this;
          //操作DOM
          $('.group-info').on('click', 'a', function () {
           if(document.getElementById('username').value==''){
              //document.getElementById('username').style.display='';
              $('.uname').css('display','block');
              return;
           }else{
            $('.uname').css('display','none');
           }
           if(document.getElementById('password').value == ''){
               $('.upass').css('display','block');
              return;
           }else{
             $('.upass').css('display','none');
           }

          document.getElementById('punishformID')['from'] = '';

           passport.checkJsonpForm(document.getElementById('punishformID'),function(result){
              var msg = result.msg;//提示信息
              var errorCode = result.errorCode;//错误码，i18n展示用
              if(passport.usernameError==result.type){//如果是用户名有问题
                $('.upass').css('display','block');

                $('#password').val('');
                //在用户名的位置展示错误提示信息
              }else if(passport.passwordError==result.type){//如果是密码有问题
                //alert(msg)
                $('.uname').css('display','block');
                $('#password').val('');
                //在密码的位置展示错误提示信息
              } else if(passport.success==result.type){//登录成功
                $('#login_Alert').modal('hide');
                $('#chatModal .info-mess').html('登录成功');
                $('#chatModal').modal('show');
                setTimeout(function(){
                  $('#chatModal').modal('hide');
                  var thisPathRoute = that.$route.path.split('/')[1];
                  if (thisPathRoute ==='detail') {
                    that.$http.get(API.IsJoin, {params: {activity_id: that.$route.params.id}})
                      .then(function (res) {
                        if (res.code == 0) {
                          if (res.data.isJoin == 0) {
                            that.$router.push({name: 'Notice', params: {id: that.$route.params.id}})
                          } else {
                            // that.$router.push({name: 'myActivity_MyParticipate', params: {id: that.$route.params.id}});
                            that.$router.push({name: 'Revise', params: {id: that.$route.params.id,form_id:0}});
                            return false;
                          }
                        }
                    })

                  } else {
                    window.location.reload()
                  }
                },1500)
              }

           });
    });

  }

}
</script>

<style>
  .close {
    color: #000;
    border-radius: 12px;
    line-height: 20px;
    text-align: center;
    font-size: 18px;
    padding: 1px;
    top: 1px;
    right: 2px;
    position: absolute;
  }
  .close::before {
    content: "\2716";
  }
</style>



// WEBPACK FOOTER //
// src/components/loginAlert/signIn.vue